'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactBootstrap = require('react-bootstrap');

var _components = require('components');

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _reviews = require('redux/modules/reviews');

var reviewActions = _interopRequireWildcard(_reviews);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

var _lodash = require('lodash');

var _reactRedux = require('react-redux');

var _lib = require('helpers/lib');

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _timers = require('timers');

var _LocationDetail = require('./LocationDetail');

var _LocationDetail2 = _interopRequireDefault(_LocationDetail);

var _GalleryDetail = require('./GalleryDetail');

var _GalleryDetail2 = _interopRequireDefault(_GalleryDetail);

var _InfoDetail = require('./InfoDetail');

var _InfoDetail2 = _interopRequireDefault(_InfoDetail);

var _Booking = require('./Booking');

var _Booking2 = _interopRequireDefault(_Booking);

var _BookingServices = require('./BookingServices');

var _BookingServices2 = _interopRequireDefault(_BookingServices);

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Detail = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        id = _ref.params.id;

    var promises = [];
    if (!shopActions.isLoadedDetail(getState())) {
      promises.push(dispatch(shopActions.getShopDataServer(id)));
    }
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    shop: state.shops.shop,
    datesHaveBooking: state.shops.datesHaveBooking,
    bookingDate: state.shops.bookingDate,
    reviews: state.shops.reviews,
    postCount: state.reviews.postCount,
    getOneLoading: state.shops.getOneLoading,
    categories: state.setup.categories,
    loading: state.shops.loading_detail,
    loaded: state.shops.loaded_detail,
    groupServices: state.booking.groupServices,
    reviewLoad: state.shops.reviewLoad
  };
}, (0, _extends3.default)({}, shopActions, reviewActions, authActions, {
  loadService: bookingActions.loadService
})), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Detail, _Component);

  function Detail() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Detail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Detail.__proto__ || (0, _getPrototypeOf2.default)(Detail)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      activeTab: 'gallery',
      bookmarkStatus: false,
      files: [],
      firstLoad: false,
      fixedTab: false,
      id: '',
      likes: 0,
      likeStatus: false,
      loaded: false,
      loadReview: false,
      showFullComment: false,
      showModalAlertLogin: false,
      showModalNewReview: false,
      showUpload: false
    }, _this.onErrorImage = function (event) {
      event.target.onerror = null;
      event.target.src = '/error-img.svg';
    }, _this.onScroll = function () {
      try {
        if (window.scrollY <= 426 && _this.state.fixedTab === true || document.body.scrollTop <= 426 && _this.state.fixedTab === true) {
          _this.setState({ fixedTab: false });
        }
        if (window.scrollY > 426 && _this.state.fixedTab === false || document.body.scrollTop > 426 && _this.state.fixedTab === false) {
          _this.setState({ fixedTab: true });
        }
      } catch (err) {
        console.log(err);
      }
    }, _this.scrollToDomRef = function (id) {
      var domNode = _reactDom2.default.findDOMNode(_this.refs[id]).offsetTop;
      // window.scrollTo(domNode.y, 92);
      if (_this.state.fixedTab) {
        domNode -= 60;
      } else {
        domNode -= 125;
      }
      domNode = domNode < 420 ? 420 : domNode;
      try {
        window.scrollTo({
          top: domNode,
          behavior: 'smooth'
        });
        document.body.scrollTo({
          top: domNode,
          behavior: 'smooth'
        });
      } catch (err) {
        console.log(err);
      }
      _this.setState({ activeTab: id });
    }, _this.handleShowModalNewReview = function () {
      if (_this.props.user) {
        _this.setState({ showModalNewReview: true });
      } else {
        _this.setState({ showModalAlertLogin: true });
        window.removeEventListener('scroll', _this.onScroll, false);
        document.body.removeEventListener('scroll', _this.onScroll, false);
      }
    }, _this.handleCloseModalNewReview = function () {
      _this.setState({ showModalNewReview: false });
    }, _this.handleCloseModalAlertLogin = function () {
      _this.setState({ showModalAlertLogin: false });
    }, _this.handleClose = function () {
      _this.setState({ showUpload: false });
    }, _this.handleShow = function () {
      _this.setState({ showUpload: true });
    }, _this.likeShop = function () {
      if (!_this.props.user) {
        _this.setState({
          showModalAlertLogin: true
        });
      } else {
        _this.props.likeShop(_this.props.shop._id);
      }
    }, _this.openLogin = function () {
      _this.setState({ showModalAlertLogin: true });
    }, _this.bookmarkShop = function () {
      if (!_this.props.user) {
        _this.setState({
          showModalAlertLogin: true
        });
      } else {
        _this.props.bookmarkShop(_this.props.shop._id);
      }
    }, _this.handleClickLogin = function () {
      _this.handleCloseModalAlertLogin();
      (0, _timers.setTimeout)(function () {
        _this.props.openLoginFormAction();
      }, 500);
    }, _this.showMore = function (reviewLength, total) {
      var rest = total - reviewLength;
      if (rest > 0) {
        var page = reviewLength / 8 + 1;
        var pageSize = rest - 8 >= 0 ? 8 : rest;
        _this.props.getReview(page, _this.props.shop._id, pageSize);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Detail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.onScroll, false);
      document.body.addEventListener('scroll', this.onScroll, false);
      // if (!this.props.shop || this.props.shop.handle !== this.props.params.id) {
      this.props.getShopData(this.props.params.id);
      this.props.loadService(this.props.shop._id && this.props.shop._id);
      // }
      // this.props.checkBooking(this.props.params.id);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.setState({
        firstLoad: false,
        getGeocoding: false,
        center: null
      });
      this.props.unSetDetail();
      // window.scroll(0, 0);
      window.removeEventListener('scroll', this.onScroll, false);
      document.body.removeEventListener('scroll', this.onScroll, false);
      this.props.resetShopData();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (!(0, _lodash.isEqual)(nextProps.reviews, this.props.reviews)) {
        (0, _timers.setTimeout)(function () {
          return _this2.setState({
            showModalNewReview: false
          });
        }, 500);
      }
      if (this.props.params.id !== nextProps.params.id) {
        this.props.getShopData(nextProps.params.id);
        this.props.loadService(nextProps.params.id);
      }
      if (!(0, _lodash.isEqual)(this.props.shop, nextProps.shop)) {
        this.props.loadService(nextProps.shop._id);
      }
      if (this.props.shop && (!(0, _lodash.isEqual)(this.props.shop.totalLike, nextProps.shop.totalLike) || !(0, _lodash.isEqual)(this.props.shop.totalBookmark, nextProps.shop.totalBookmark))) {
        this.props.getShopData(this.props.params.id);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(files) {
      this.setState({
        files: files
      });
    }
  }, {
    key: 'handleJoinPromotion',
    value: function handleJoinPromotion() {
      // TODO join promotion
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./Detail.scss');
      var _props = this.props,
          shop = _props.shop,
          reviewLoad = _props.reviewLoad,
          loading = _props.loading,
          user = _props.user,
          location = _props.location,
          loaded = _props.loaded,
          datesHaveBooking = _props.datesHaveBooking,
          groupServices = _props.groupServices;
      var reviews = reviewLoad.reviews,
          total = reviewLoad.total;
      var _state = this.state,
          showModalNewReview = _state.showModalNewReview,
          showModalAlertLogin = _state.showModalAlertLogin,
          fixedTab = _state.fixedTab,
          activeTab = _state.activeTab;

      var cmtLength = reviews ? reviews.length : 0;
      var reviewsRender = reviews ? reviews : [];
      // TODO tính điểm, gom lại
      var positiveReviews = 0;
      var averageReviews = 0;
      var negativeReviews = 0;
      var positiveReviewsRatio = 0;
      var averageReviewsRatio = 0;
      var negativeReviewsRatio = 0;
      var averagePoint = 0;
      var numberReview = 0;
      reviewsRender.map(function (review) {
        if (review.rating >= 8) {
          positiveReviews++;
        } else if (review.rating >= 5) {
          averageReviews++;
        } else {
          negativeReviews++;
        }
        numberReview += 1;
      });
      if (numberReview > 0) {
        averagePoint = shop && shop.averagePoint || 0;
        positiveReviewsRatio = Math.round(positiveReviews / numberReview * 100);
        averageReviewsRatio = Math.round(averageReviews / numberReview * 100);
        negativeReviewsRatio = Math.round(negativeReviews / numberReview * 100);
      }
      var stylePoint = {
        borderColor: (0, _lib.getColorRatingCode)(averagePoint),
        backgroundColor: averagePoint === 0 ? (0, _lib.getColorRatingCode)(0) : '#14BBBA'
      };
      var likeStatus = user && shop && shop.isLiked ? shop.isLiked : false;
      var bookmarkStatus = user && shop && shop.isBookmarked ? shop.isBookmarked : false;
      return _react2.default.createElement(
        'div',
        { className: styles.detail },
        _react2.default.createElement(_components.HelmetSEO, { shopSeo: shop, location: location, loaded: loaded }),
        loading && _react2.default.createElement(_components.Loading, null),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          shop && _react2.default.createElement(
            'div',
            { className: styles.topContent },
            _react2.default.createElement(
              'div',
              { className: styles.image },
              _react2.default.createElement('img', {
                src: (0, _lib.getUrlImage)(shop.image),
                alt: (shop ? shop.name : 'detail') + ' avatar',
                onError: this.onErrorImage
              })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.content },
              _react2.default.createElement(
                'div',
                { className: styles.leftContent },
                _react2.default.createElement(
                  'div',
                  { className: styles.primary },
                  _react2.default.createElement(
                    'h1',
                    { className: styles.name },
                    shop.name
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.category },
                    (0, _lib.paserCategory)(this.props.categories, shop.category)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.extra },
                  _react2.default.createElement(
                    'div',
                    { className: styles.address },
                    _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'map-marker' }),
                    shop.addressDisplay ? shop.addressDisplay : shop.address
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.openingTime },
                    _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'time' }),
                    shop.openTime && shop.closeTime ? (0, _lib.number2Time)(shop.openTime) + ' - ' + (0, _lib.number2Time)(shop.closeTime) : shop.opening_time
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.priceRange },
                    _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'tag' }),
                    shop.minPrice && shop.maxPrice ? (0, _numeral2.default)(shop.minPrice).format('0,0') + 'đ - ' + (0, _numeral2.default)(shop.maxPrice).format('0,0') + 'đ' : shop.priceRange
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.phone },
                    _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'phone' }),
                    shop.phone
                  )
                ),
                shop && shop.owner_id && datesHaveBooking && _react2.default.createElement(_Booking2.default, {
                  id: this.props.params.id,
                  openLogin: this.openLogin
                })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.rightContent },
                _react2.default.createElement(
                  'div',
                  { className: styles.point, style: stylePoint },
                  averagePoint === 0 ? '--' : averagePoint
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.summary },
                  _react2.default.createElement(
                    'div',
                    { className: styles.totalLike },
                    _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'heart' }),
                    shop.totalLike
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.totalComment },
                    _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'comment' }),
                    reviewsRender.length
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.groupAction },
                  _react2.default.createElement(
                    'div',
                    {
                      className: styles.like + (likeStatus ? ' ' + styles.primaryText : ''),
                      onClick: function onClick() {
                        return _this3.likeShop();
                      }
                    },
                    _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'heart' }),
                    likeStatus ? 'Bỏ thích' : 'Thích'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.comment },
                    _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'pencil' }),
                    _react2.default.createElement(
                      'span',
                      { onClick: function onClick() {
                          return _this3.handleShowModalNewReview();
                        } },
                      'B\xECnh Lu\u1EADn'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.uploadImage + ' display-none' },
                    _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'picture' }),
                    '\u0110\u0103ng \u1EA2nh'
                  ),
                  _react2.default.createElement(
                    'div',
                    {
                      className: styles.save + (bookmarkStatus ? ' ' + styles.primaryText : ''),
                      onClick: function onClick() {
                        return _this3.bookmarkShop();
                      }
                    },
                    _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'flag' }),
                    bookmarkStatus ? 'Huỷ lưu' : 'Lưu'
                  )
                )
              )
            )
          ),
          shop && _react2.default.createElement(
            'div',
            { className: styles.bodyContent },
            _react2.default.createElement(
              'div',
              { className: styles.tabs },
              _react2.default.createElement(
                'div',
                {
                  className: styles.headerTabContainer + (fixedTab ? ' ' + styles.fixedTabbar : '')
                },
                _react2.default.createElement(
                  'div',
                  { className: styles.headerTabs },
                  _react2.default.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this3.scrollToDomRef('gallery');
                      },
                      className: activeTab === 'gallery' ? styles.activeTab : ''
                    },
                    'H\xECnh \u1EA3nh'
                  ),
                  _react2.default.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this3.scrollToDomRef('comment');
                      },
                      className: activeTab === 'comment' ? styles.activeTab : ''
                    },
                    'B\xECnh lu\u1EADn (',
                    total,
                    ')'
                  ),
                  groupServices && groupServices.length > 0 && _react2.default.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this3.scrollToDomRef('services');
                      },
                      className: activeTab === 'services' ? styles.activeTab : ''
                    },
                    'D\u1ECBch v\u1EE5'
                  ),
                  _react2.default.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this3.scrollToDomRef('location');
                      },
                      className: activeTab === 'location' ? styles.activeTab : ''
                    },
                    'V\u1ECB Tr\xED'
                  ),
                  shop && shop.owner_id && _react2.default.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this3.scrollToDomRef('about');
                      },
                      className: activeTab === 'about' ? styles.activeTab : ''
                    },
                    'Gi\u1EDBi Thi\u1EC7u'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.contentTabs },
                _react2.default.createElement(_GalleryDetail2.default, { ref: 'gallery' }),
                groupServices && groupServices.length > 0 && _react2.default.createElement(_BookingServices2.default, {
                  shop: shop,
                  groupServices: groupServices,
                  ref: 'services'
                }),
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.contentTab + ' ' + styles.comment,
                    id: 'comment',
                    ref: 'comment'
                  },
                  _react2.default.createElement(
                    'div',
                    { className: styles.headerTab },
                    _react2.default.createElement(
                      'h2',
                      { className: styles.leftHeaderTab },
                      _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'pencil' }),
                      'B\xECnh lu\u1EADn'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.bodyTab },
                    numberReview > 0 && _react2.default.createElement(
                      'div',
                      { className: styles.summaryComment },
                      _react2.default.createElement(
                        _reactBootstrap.Col,
                        { md: 3, className: styles.groupTotalComment },
                        'T\u1ED5ng c\u1ED9ng:',
                        ' ',
                        _react2.default.createElement(
                          'span',
                          { className: styles.totalComment },
                          numberReview,
                          '/',
                          total,
                          ' b\xECnh lu\u1EADn'
                        )
                      ),
                      _react2.default.createElement(
                        _reactBootstrap.Col,
                        { md: 3, className: styles.groupPoint },
                        _react2.default.createElement(
                          'div',
                          { className: styles.labelPoint },
                          '\u0110i\u1EC3m trung b\xECnh:',
                          ' '
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: styles.point, style: stylePoint },
                          averagePoint === 0 ? '--' : averagePoint
                        )
                      ),
                      _react2.default.createElement(
                        _reactBootstrap.Col,
                        { md: 6, className: styles.groupProgress },
                        _react2.default.createElement(
                          'div',
                          { className: styles.labelProgress },
                          'T\u1EC9 l\u1EC7 \u0111\xE1nh gi\xE1:',
                          ' '
                        ),
                        reviewsRender.length > 0 && _react2.default.createElement(
                          _reactBootstrap.ProgressBar,
                          { className: styles.progressBar },
                          _react2.default.createElement(_reactBootstrap.ProgressBar, {
                            bsStyle: 'success',
                            now: positiveReviewsRatio,
                            key: 1,
                            min: 0,
                            max: 100
                          }),
                          _react2.default.createElement(_reactBootstrap.ProgressBar, {
                            bsStyle: 'warning',
                            now: averageReviewsRatio,
                            key: 2,
                            min: 0,
                            max: 100
                          }),
                          _react2.default.createElement(_reactBootstrap.ProgressBar, {
                            bsStyle: 'danger',
                            now: negativeReviewsRatio,
                            key: 3,
                            min: 0,
                            max: 100
                          })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.comments },
                      reviewsRender.length > 0 && reviewsRender.map(function (review, idx) {
                        return _react2.default.createElement(_components.Review, {
                          shop: shop,
                          review: review,
                          key: 'review_' + idx
                        });
                      }),
                      reviewsRender.length < 0 && shop.review_guest && _react2.default.createElement(_components.Review, { review: shop.review_guest, key: 'review' }),
                      _react2.default.createElement(
                        'div',
                        {
                          className: styles.comment + ' ' + styles.newComment + (cmtLength % 2 === 0 ? ' ' + styles.fullWidth : '')
                        },
                        _react2.default.createElement(
                          'div',
                          { className: styles.newCmtTitle },
                          'Tham gia b\xECnh lu\u1EADn'
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: styles.newCmtText },
                          'H\xE3y chia s\u1EBB \u0111\xE1nh gi\xE1 \u0111i\u1EC3m l\xE0m \u0111\u1EB9p c\u1EE7a m\xECnh cho c\u1ED9ng \u0111\u1ED3ng ',
                          _react2.default.createElement(
                            'strong',
                            null,
                            'Lookme'
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: styles.btnContainer },
                          _react2.default.createElement(
                            'div',
                            {
                              className: styles.btnNewCmt,
                              onClick: function onClick() {
                                return _this3.handleShowModalNewReview();
                              }
                            },
                            'VI\u1EBET B\xCCNH LU\u1EACN'
                          ),
                          _react2.default.createElement(
                            'div',
                            {
                              className: styles.btnReadMore,
                              onClick: function onClick() {
                                return _this3.showMore(reviews.length, total);
                              }
                            },
                            'XEM TH\xCAM'
                          )
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(_LocationDetail2.default, { ref: 'location' }),
                _react2.default.createElement(_InfoDetail2.default, { ref: 'about' })
              )
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          { show: showModalNewReview, hide: this.handleCloseModalNewReview },
          _react2.default.createElement(
            'div',
            {
              className: 'close-modal-button',
              onClick: this.handleCloseModalNewReview
            },
            _react2.default.createElement('i', { className: 'fa fa-times' })
          ),
          _react2.default.createElement(_components.NewReview, {
            shop: shop,
            likes: shop && shop.totalLike,
            totalCmt: reviewsRender.length
          })
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: showModalAlertLogin,
            hide: this.handleCloseModalAlertLogin,
            className: 'modal-alert-login'
          },
          _react2.default.createElement(
            'div',
            {
              className: 'close-modal-button',
              onClick: this.handleCloseModalAlertLogin
            },
            _react2.default.createElement('i', { className: 'fa fa-times' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalAlert },
            _react2.default.createElement(
              'div',
              { className: styles.headerAlert },
              'Th\xF4ng b\xE1o'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.contentAlert },
              'B\u1EA1n c\u1EA7n ph\u1EA3i \u0111\u0103ng nh\u1EADp \u0111\u1EC3 c\xF3 th\u1EC3 tham gia b\xECnh lu\u1EADn'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.actionButtons },
              _react2.default.createElement(
                'div',
                {
                  className: styles.btnLogin,
                  onClick: function onClick() {
                    return _this3.handleClickLogin();
                  }
                },
                '\u0110\u0103ng nh\u1EADp'
              ),
              _react2.default.createElement(
                'div',
                {
                  className: styles.btnCancel,
                  onClick: this.handleCloseModalAlertLogin
                },
                'Hu\u1EF7'
              )
            )
          )
        )
      );
    }
  }]);
  return Detail;
}(_react.Component), _class2.propTypes = {
  bookingDate: _react.PropTypes.object,
  bookmarkShop: _react.PropTypes.func,
  categories: _react.PropTypes.array,
  datesHaveBooking: _react.PropTypes.array,
  getBooking: _react.PropTypes.func.isRequired,
  checkBooking: _react.PropTypes.func.isRequired,
  getOneLoading: _react.PropTypes.bool,
  resetShopData: _react.PropTypes.func,
  getShopData: _react.PropTypes.func.isRequired,
  loadService: _react.PropTypes.func,
  likeShop: _react.PropTypes.func,
  loaded: _react.PropTypes.bool,
  loading: _react.PropTypes.bool,
  location: _react.PropTypes.object,
  openLoginFormAction: _react.PropTypes.func,
  params: _react.PropTypes.object,
  postCount: _react.PropTypes.number,
  reviews: _react.PropTypes.array,
  shop: _react.PropTypes.object,
  groupServices: _react.PropTypes.array,
  unSetDetail: _react.PropTypes.func,
  user: _react.PropTypes.object,
  reviewLoad: _react.PropTypes.object,
  getReview: _react.PropTypes.func.isRequired
}, _temp2)) || _class) || _class);
exports.default = Detail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Detail/Detail.js
// module id = 1667
// module chunks = 0